<template>
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4">
      <div v-if="title" class="mb-4 pb-2 border-b dark:border-gray-700">
        <h3 class="text-lg font-medium text-gray-700 dark:text-gray-200">{{ title }}</h3>
      </div>
      
      <div class="grid grid-cols-3 gap-x-4">
        <!-- Primeiro Stats -->
        <div @click="$emit('clickStat1')" class="flex flex-col items-center text-center cursor-pointer">
          <p class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{{ stat1Title }}</p>
          <p :class="[
            'text-xl font-semibold', 
            stat1TextColor ? stat1TextColor : 'text-gray-800 dark:text-gray-200'
          ]">{{ stat1Value }}</p>
          <p v-if="stat1Subtitle" :class="[
            'text-xs mt-1', 
            stat1SubtitleColor ? stat1SubtitleColor : 'text-gray-500 dark:text-gray-400'
          ]">{{ stat1Subtitle }}</p>
        </div>
        
        <!-- Segundo Stats -->
        <div @click="$emit('clickStat2')" class="flex flex-col items-center text-center cursor-pointer border-x dark:border-gray-700">
          <p class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{{ stat2Title }}</p>
          <p :class="[
            'text-xl font-semibold', 
            stat2TextColor ? stat2TextColor : 'text-gray-800 dark:text-gray-200'
          ]">{{ stat2Value }}</p>
          <p v-if="stat2Subtitle" :class="[
            'text-xs mt-1', 
            stat2SubtitleColor ? stat2SubtitleColor : 'text-gray-500 dark:text-gray-400'
          ]">{{ stat2Subtitle }}</p>
        </div>
        
        <!-- Terceiro Stats -->
        <div @click="$emit('clickStat3')" class="flex flex-col items-center text-center cursor-pointer">
          <p class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            {{ stat3Title }}
            <slot name="stat3TitleIcon"></slot>
          </p>
          <p :class="[
            'text-xl font-semibold', 
            stat3TextColor ? stat3TextColor : 'text-gray-800 dark:text-gray-200'
          ]">{{ stat3Value }}</p>
          <p v-if="stat3Subtitle" :class="[
            'text-xs mt-1', 
            stat3SubtitleColor ? stat3SubtitleColor : 'text-gray-500 dark:text-gray-400'
          ]">{{ stat3Subtitle }}</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MultiStatsCard',
    props: {
      title: {
        type: String,
        default: ''
      },
      // Primeiro Stats
      stat1Title: {
        type: String,
        required: true
      },
      stat1Value: {
        type: [String, Number],
        required: true
      },
      stat1Subtitle: {
        type: String,
        default: ''
      },
      stat1Color: {
        type: String,
        default: 'blue'
      },
      stat1TextColor: {
        type: String,
        default: ''
      },
      stat1SubtitleColor: {
        type: String,
        default: ''
      },
      // Segundo Stats
      stat2Title: {
        type: String,
        required: true
      },
      stat2Value: {
        type: [String, Number],
        required: true
      },
      stat2Subtitle: {
        type: String,
        default: ''
      },
      stat2Color: {
        type: String,
        default: 'blue'
      },
      stat2TextColor: {
        type: String,
        default: ''
      },
      stat2SubtitleColor: {
        type: String,
        default: ''
      },
      // Terceiro Stats
      stat3Title: {
        type: String,
        required: true
      },
      stat3Value: {
        type: [String, Number],
        required: true
      },
      stat3Subtitle: {
        type: String,
        default: ''
      },
      stat3Color: {
        type: String,
        default: 'blue'
      },
      stat3TextColor: {
        type: String,
        default: ''
      },
      stat3SubtitleColor: {
        type: String,
        default: ''
      }
    },
    emits: ['clickStat1', 'clickStat2', 'clickStat3']
  };
  </script>